import { StandardAgentChat } from "@/modules/standardAgent/StandardAgentChat";

export default function StandardAgent() {
  return <StandardAgentChat />;
}
